import { CrashReporter, CrashReportContext } from './crashReporter.types'

export function makeCrashReporter(workerUrl: string): CrashReporter {
  const reportCrash = async (
    error: Error | string,
    stack: string,
    context: CrashReportContext
  ): Promise<void> => {
    const errorMsg = error instanceof Error ? error.message : String(error)
    const errorStack = error instanceof Error ? error.stack || '' : stack

    const payload = {
      gameId: context.gameId,
      error: errorMsg,
      stack: errorStack,
      context: {
        ...context,
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined
      }
    }

    try {
      const res = await fetch(`${workerUrl}/api/telemetry/crash`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      if (!res.ok) {
        console.error(`[CrashReporter] Failed to send report: ${res.status} ${await res.text().catch(() => '')}`)
      }
    } catch (err) {
      console.error('[CrashReporter] Fetch error:', err)
    }
  }

  return { reportCrash }
}
